import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";

import {
  LOGIN_REQUEST,
  loginSuccess,
  loginError,
  LOGOUT_REQUEST,
  logoutSuccess,
} from "./actions";
import { saveAuthData, clearAuthData } from "../utils/auth/authData";
import { Env } from "../../env";

function* loginRequest(action) {
  const { email, password } = action;
  let response;

  try {
    response = yield call(axios.post, `${Env.BASE_API_URL}/Accounts/login`, {
      email,
      password,
    });
  } catch (err) {
    let error;
    if (err.response && err.response.status === 401) {
      console.log(err.response);
      if (
        err.response.data &&
        err.response.data.error &&
        err.response.data.error.code === "LOGIN_FAILED_EMAIL_NOT_VERIFIED"
      ) {
        error =
          "Votre email n'a pas été validé. Veuillez vérifier votre boite mail et cliquez sur le lien qu'il contient.";
      } else if (
        err.response.data &&
        err.response.data.error &&
        err.response.data.error.message === "User Deactivated"
      ) {
        error = err.response.data.error.message;
      } else {
        error = "Email ou mot de passe incorrect.";
      }
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
    }

    window.loginFails = (window.loginFails || 0) + 1;
    if (window.loginFails > 2 && window.$crisp) {
      $crisp.push([
        "do",
        "message:show",
        [
          "text",
          "Il semblerait que vous ayez des problèmes de connexion. Pouvons-nous vous aider ?",
        ],
      ]);
    }

    yield put(loginError());
    yield put(flashMessage(error));

    return;
  }

  const authData = response.data;
  saveAuthData(authData);
  console.log("dsdfd", authData);
  yield put(loginSuccess(authData));
}

export function* watchLoginRequest() {
  yield takeLatest(LOGIN_REQUEST, loginRequest);
}

function* logoutRequest() {
  clearAuthData();
  yield put(logoutSuccess());
}

export function* watchLogoutRequest() {
  yield takeLatest(LOGOUT_REQUEST, logoutRequest);
}



// WEBPACK FOOTER //
// ./src/pages/login/saga.js